import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const PrimaryBGColor = styled.div`
  overflow: ${(props) => (props.content ? "hidden" : "visible")};
  background-color: ${(props) => props.background};
  border-radius:  0 0 48px 48px;
`;

export const BGGrid = styled(Grid)`
  position: relative;
`;
